<button
  [class]="className"
  fpxClickDbclick
  (onclick)="onBtnClick($event)"
  (doubleClick)="onBtnDoubleClick($event)"
  [type]="btnType"
  [disabled]="disable"
>
  {{ label }}
</button>
